import React from 'react';
import { makeStyles } from 'tss-react/mui';
import palette from '@ui/palette';
import Button from '@ui/Button';
import usePromptForSubscriptionUpgrade from '../usePromptForSubscriptionUpgrade';

const useStyles = makeStyles()(() => ({
  button: {
    background: `linear-gradient(266deg, ${palette.chartreuse_300} 5.61%, ${palette.sunflower_300} 96.22%)`,
    /**
     * @todo: this should be 8px 16px - implement once layout is updated to accommodate for the new size
     */
    padding: '8px 12px',
    height: '24px',
    minWidth: 'unset',
    transition: 'background 0.2s ease',
    '&:hover': {
      background: `linear-gradient(266deg, ${palette.chartreuse_200} 5.61%, ${palette.sunflower_200} 96.22%)`,
      backgroundColor: 'transparent',
      boxShadow: 'none',
    },
  },
}));

const UpgradeHeaderButton = () => {
  const { classes } = useStyles();
  const [openUpgradePrompt] = usePromptForSubscriptionUpgrade({
    upgradeContext: 'increase_access',
    upgradePath: 'Dashboard > Breadcrumb bar',
  });

  return (
    <Button
      variant="primary"
      size="small"
      type="button"
      data-e2e="wsl-upgrade-header-button"
      className={classes.button}
      onClick={() => openUpgradePrompt()}
    >
      Upgrade
    </Button>
  );
};

export default UpgradeHeaderButton;
